import { FunctionalComponent } from 'preact'

/**
 * Loading skeleton row for tables
 */
export const LoadingRow: FunctionalComponent = () => (
  <tr class="animate-pulse">
    <td class="py-3 px-4" colSpan={7}>
      <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded" />
    </td>
  </tr>
)

/**
 * Error state component for tables with retry button
 */
export const ErrorState: FunctionalComponent<{ error: string; onRetry: () => void }> = ({ error, onRetry }) => (
  <div class="p-6 text-center">
    <p class="text-sm text-red-600 dark:text-red-400 mb-3">Failed to load leads: {error}</p>
    <button
      onClick={onRetry}
      class="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded bg-indigo-600 text-white hover:bg-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-400"
    >
      Retry
    </button>
  </div>
)

/**
 * Empty state component for tables
 */
export const EmptyState: FunctionalComponent<{ message: string }> = ({ message }) => (
  <div class="p-10 text-center border border-dashed border-gray-300 dark:border-gray-600 rounded-lg">
    <p class="text-sm text-gray-600 dark:text-gray-400">{message}</p>
  </div>
)
